import { useNow } from '@vueuse/core'

export const currentTime = useNow({ interval: 1_000 })
